import {
  InternalServerError,
  NetworkError,
} from 'app/ProfileRevampPage/utils/customError'
import { ForbiddenError } from 'utils/customError'

export const getErrorType = (error): string => {
  if (error instanceof InternalServerError) {
    return 'InternalServerError'
  } else if (error instanceof NetworkError) {
    return 'NetworkError'
  } else if (error instanceof ForbiddenError) {
    return 'ForbiddenError'
  }

  return 'UnknownError'
}
